
import React from 'react';

import styled from 'styled-components';

const StyledH1 = styled.h1`
  font-size: 30px;
  line-height: 35px;
  
  @media (max-width: 767px) {
    font-size: 24px;
  }
`;


export function H1(props) {
  return (
    <StyledH1>{props.children}</StyledH1>
  )
}
